// extracted by mini-css-extract-plugin
export default {"container":"GetAIAddOn_container__WgZ5a"};